import { render } from "./xAppsXCoolPage.vue?vue&type=template&id=bc807b1e&scoped=true"
import script from "./xAppsXCoolPage.vue?vue&type=script&lang=js"
export * from "./xAppsXCoolPage.vue?vue&type=script&lang=js"

import "./xAppsXCoolPage.vue?vue&type=style&index=0&id=bc807b1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc807b1e"]])

export default __exports__